import axios from "axios";

export const validateOtp = async (otp, empId, requestDate) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/validate-otp`,
      {
        otp,
        empId,
        request_date: requestDate,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Validate OTP API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};

export const requestOtp = async (email) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/request-otp`,
      {
        email,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Request OTP API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};

export const changePassword = async (employeeId, password) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/employee/change-password/${employeeId}`,
      { password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Change Password API Error:", error);
    throw (
      error.response?.data || { status: false, message: "An error occurred" }
    );
  }
};
